import { DialogTitle, IconButton } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from 'react-redux';
import { getMediaFromLibrary } from '../../redux/slices/common';
import { useSelector } from 'react-redux';

const UploadFromLibraryImage = ({ closeModal }) => {
  const dispatch = useDispatch()
  const { modalData } = useSelector((state) => state.modal);
  const { type: imageType, handleSave: onSave, viewData } = modalData;

  useEffect(() => {
    dispatch(getMediaFromLibrary())
      .unwrap()
      .then((res) => {
      })
      .catch((err) => {
      });

  }, [])


  return (
    <>
      <DialogTitle
        id="draggable-dialog-title"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        My Media
        <IconButton onClick={closeModal} edge="end" size="small">
          <CloseIcon fontSize="medium" />
        </IconButton>
      </DialogTitle>
    </>
  )
}

export default UploadFromLibraryImage
